import * as THREE from "three";
import Instruction from "./instruction";

export default class THREEWindow extends Instruction {
    constructor (width, height) {
        super();

        this.name = "THREEWindow";

        Object.assign(this.s, {
            width      : width ? width : window.innerWidth,
            height     : height ? height : window.innerHeight,
            fullscreen : (!width && !height)
        });
    }

    setup () {
        this.a.renderer = new THREE.WebGLRenderer();
        this.a.renderer.setSize(this.s.width, this.s.height);

        this.a.renderer.domElement.style.display = "block";

        var oldmargin = document.body.style.margin;

        this.external(() => {
            document.body.style.margin = "0";
            document.body.appendChild(this.a.renderer.domElement);
        }, () => {
            document.body.style.margin = oldmargin;
            document.body.removeChild(this.a.renderer.domElement);
        });

        this.external(() => {
            this.game.addGamewindow(this, this.name);
        }, () => {
            this.game.removeGamewindows(this.name);
        });
    }

    render () {
        if (this.a.scene && this.a.camera) this.a.renderer.render(this.a.scene, this.a.camera);
    }

    resize (screenwidth, screenheight) {
        if (!this.s.fullscreen) return;

        this.s.width = screenwidth;
        this.s.height = screenheight;

        this.a.renderer.setSize(screenwidth, screenheight);
        if (this.a.camera) {
            this.a.camera.aspect = screenwidth/screenheight;
            this.a.camera.updateProjectionMatrix();
        }
    }
}
